import * as React from 'react'
import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { INotification } from '@user/store/notifications/typings'
import { toggleNotification } from '@user/store/notifications/api'
import { NotificationCard } from '.'
import { SideDrawer } from '@sales-center/components'

import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { ManageAutoReminderSlideout } from '../forms/ManageAutoReminderSlideout'
import { useDialogState } from '@user/utils/useDialogState'

type Props = {
  notification: INotification
}

export function AutoReminderNotification(props: Props) {
  const { notification } = props

  const dispatch = useAppDispatch()

  const [loading, setLoading] = useState(false)
  const onChange = useCallback(async () => {
    setLoading(true)
    await dispatch(toggleNotification(notification.id))
    setLoading(false)
  }, [dispatch, notification.id])

  const [
    custAutoReminderOpen,
    onOpenCustAutoReminder,
    onCloseCustAutoReminder,
  ] = useDialogState()

  return (
    <>
      <NotificationCard
        type="Customer"
        name="Agreement Reminders"
        helperText={notification.helperText}
        rightContent={
          <Button
            color="primary"
            variant="outlined"
            onClick={onOpenCustAutoReminder}
            data-test-id="manageNotificationBtn"
          >
            Manage
          </Button>
        }
        bottomContent={
          <FormControlLabel
            label="Off/On"
            disabled={loading}
            control={
              <Switch checked={notification.isEnabled} onChange={onChange} />
            }
          />
        }
      />
      <SideDrawer
        title="Agreement Reminders"
        open={custAutoReminderOpen}
        onClose={onCloseCustAutoReminder}
      >
        <ManageAutoReminderSlideout
          notification={notification}
          onClose={onCloseCustAutoReminder}
        />
      </SideDrawer>
    </>
  )
}
